import { useCallback } from "react";
import {
  StorecastAdminPopoverSectionDashboard,
  StorecastAdminPopoverSectionStore,
} from "./StorecastAdminPopover";
import { UserLoggedInNavigatorNavigationProp } from "../../../../TopLevelNavigators/UserLoggedIn/UserLoggedInNavigatorParamList";
import { PopoverButton } from "../../../../common/PopoverButton";
import { useIntlTokens } from "../../../../components/mobile/useIntlTokens";
import { StorecastHeaderButton } from "./StorecastHeaderButton";
import { AHSeparator, Box } from "arkh";
import { graphql, useFragment } from "react-relay";
import { StorecastAdminButton_Dashboard$key } from "./__generated__/StorecastAdminButton_Dashboard.graphql";
import { StorecastAdminButton_Store$key } from "./__generated__/StorecastAdminButton_Store.graphql";

export function StorecastAdminButton(props: {
  dashboard: StorecastAdminButton_Dashboard$key | null;
  store: StorecastAdminButton_Store$key | null;
  navigation: UserLoggedInNavigatorNavigationProp<"Dashboard">;
  onPressEditLayoutAndWidgets: () => void;
  isCompact: boolean;
}) {
  const dashboard = useFragment(
    graphql`
      fragment StorecastAdminButton_Dashboard on Dashboard {
        ...StorecastAdminPopoverSectionDashboard_Dashboard
      }
    `,
    props.dashboard
  );
  const store = useFragment(
    graphql`
      fragment StorecastAdminButton_Store on Store {
        ...StorecastAdminPopoverSectionStore_Store
      }
    `,
    props.store
  );
  const { navigation, onPressEditLayoutAndWidgets, isCompact } = props;

  const intl_tokens = useIntlTokens();
  const popoverContent = useCallback(
    (close: () => void) => {
      return (
        <Box space="small">
          {store ? (
            <StorecastAdminPopoverSectionStore
              onPressStoreAdmin={() => {
                close();
                navigation.navigateDeprecated("StoreAdmin", {});
              }}
              store={store}
            />
          ) : null}
          {dashboard && store ? <AHSeparator spaceVertical="small" /> : null}
          {dashboard ? (
            <StorecastAdminPopoverSectionDashboard
              closePopover={close}
              onPressEditLayoutAndWidgets={onPressEditLayoutAndWidgets}
              dashboard={dashboard}
              navigation={navigation}
            />
          ) : null}
        </Box>
      );
    },
    [dashboard, navigation, onPressEditLayoutAndWidgets, store]
  );

  const button = useCallback(
    (open: () => void) => {
      return (
        <StorecastHeaderButton
          icon="settings"
          onPress={open}
          title={isCompact ? undefined : intl_tokens.Admin}
        />
      );
    },
    [intl_tokens.Admin, isCompact]
  );

  return (
    <PopoverButton popoverContent={popoverContent}>{button}</PopoverButton>
  );
}
